import React, { Component } from 'react'
import {
    Button, Checkbox, Descriptions, Drawer, Form, Input, InputNumber, message, Modal, Select, Space, Spin, Table, Tabs, Tag, Typography
} from 'antd'
import {
    CloudServerOutlined, DatabaseOutlined, FileTextOutlined, PlusOutlined, ReloadOutlined, SearchOutlined, SettingOutlined
} from '@ant-design/icons'
import {
    createVibeAdminApp,
    getVibeAdminAppDetail,
    getVibeAdminDepartments,
    getVibeAdminAppHealth,
    getVibeAdminAppList,
    getVibeAdminProjectTableData,
    getVibeAdminProjectTables,
    getVibeMysqlConnectionList,
    getUserListForDropbox,
    saveVibeMysqlConnection,
    syncAllVibeAdminDatabaseReadme,
    syncVibeAdminDatabaseReadme,
    updateVibeAdminDatabaseReadme,
} from '../../request'

const { Paragraph, Text } = Typography
const { TabPane } = Tabs
const { Option } = Select

const STATUS_MAP = {
    approved: { text: '待部署', color: 'processing' },
    provisioning: { text: '接入中', color: 'processing' },
    ready: { text: '已就绪', color: 'success' },
    failed: { text: '失败', color: 'error' },
    disabled: { text: '禁用', color: 'default' },
    deleted: { text: '已删除', color: 'default' },
}

export default class VibeAppManagement extends Component {
    appFormRef = React.createRef()
    connectionFormRef = React.createRef()

    state = {
        dataSource: [],
        pagination: { current: 1, pageSize: 20, total: 0 },
        keyword: '',
        dingdingDeptId: undefined,
        dingdingDepartments: [],
        loading: false,
        detailVisible: false,
        detailLoading: false,
        detail: null,
        healthLoading: false,
        health: null,
        syncing: false,
        batchSyncing: false,
        editDictionaryVisible: false,
        editDictionaryContent: '',
        editDictionarySaving: false,
        dataVisible: false,
        dataProject: null,
        tableKeyword: '',
        tableLoading: false,
        tableList: [],
        selectedTableName: '',
        dataKeyword: '',
        dataFilterColumn: undefined,
        dataFilterOperator: 'contains',
        dataFilterValue: '',
        tableDataLoading: false,
        tableColumns: [],
        tableRows: [],
        tableLastDataTime: null,
        tableDataPagination: { current: 1, pageSize: 30, total: 0 },
        users: [],
        mysqlConnections: [],
        appCreateVisible: false,
        appCreating: false,
        connectionManageVisible: false,
        connectionEditVisible: false,
        connectionSaving: false,
        editingConnection: null,
    }

    componentDidMount() {
        this.loadList()
        this.loadDepartments()
        this.loadUsers()
        this.loadMysqlConnections()
    }

    loadUsers = () => getUserListForDropbox({ type: 0 })
        .then(res => this.setState({ users: res || [] }))
        .catch(() => {})

    loadDepartments = () => getVibeAdminDepartments({})
        .then(res => this.setState({ dingdingDepartments: res || [] }))
        .catch(() => {})

    loadMysqlConnections = () => getVibeMysqlConnectionList({})
        .then(res => this.setState({ mysqlConnections: res || [] }))
        .catch(() => {})

    openCreateApp = () => {
        this.setState({ appCreateVisible: true }, () => {
            this.appFormRef.current?.resetFields()
            this.appFormRef.current?.setFieldsValue({ skipDatabaseCreation: true })
        })
    }

    submitCreateApp = () => {
        this.appFormRef.current.validateFields().then(values => {
            this.setState({ appCreating: true })
            createVibeAdminApp(values).then(() => {
                message.success('应用已创建')
                this.setState({ appCreateVisible: false })
                this.loadList(1)
            }).catch(() => {})
                .finally(() => this.setState({ appCreating: false }))
        }).catch(() => {})
    }

    openCreateConnection = () => {
        this.setState({ connectionEditVisible: true, editingConnection: null }, () => {
            this.connectionFormRef.current?.resetFields()
            this.connectionFormRef.current?.setFieldsValue({ mysqlPort: 3306, status: 'enabled' })
        })
    }

    openEditConnection = record => {
        this.setState({ connectionEditVisible: true, editingConnection: record }, () => {
            this.connectionFormRef.current?.setFieldsValue(record)
        })
    }

    getConnectionFormValues = () => this.connectionFormRef.current.validateFields()
        .then(values => ({ ...values, id: this.state.editingConnection?.id }))

    saveConnection = () => {
        this.getConnectionFormValues().then(values => {
            this.setState({ connectionSaving: true })
            saveVibeMysqlConnection(values).then(() => {
                message.success('数据库连接已保存')
                this.setState({ connectionEditVisible: false })
                this.loadMysqlConnections()
            }).catch(() => {})
                .finally(() => this.setState({ connectionSaving: false }))
        }).catch(() => {})
    }

    loadList = (pageNum = this.state.pagination.current, pageSize = this.state.pagination.pageSize) => {
        const { keyword, dingdingDeptId } = this.state
        this.setState({ loading: true })
        return getVibeAdminAppList({ pageNum, pageSize, keyword, dingdingDeptId })
            .then(res => {
                const page = res || {}
                this.setState({
                    dataSource: page.list || [],
                    pagination: {
                        current: page.pageNum || pageNum,
                        pageSize: page.pageSize || pageSize,
                        total: page.total || 0,
                    },
                })
            })
            .catch(() => {})
            .finally(() => this.setState({ loading: false }))
    }

    openDetail = (record) => {
        this.setState({ detailVisible: true, detailLoading: true, detail: null, health: null })
        getVibeAdminAppDetail({ id: record.id })
            .then(res => this.setState({ detail: res }))
            .catch(() => {})
            .finally(() => this.setState({ detailLoading: false }))
    }

    checkHealth = () => {
        const { detail } = this.state
        if (!detail?.id) return
        this.setState({ healthLoading: true })
        getVibeAdminAppHealth({ id: detail.id })
            .then(res => this.setState({ health: res }))
            .catch(() => {})
            .finally(() => this.setState({ healthLoading: false }))
    }

    syncDatabaseReadme = () => {
        const { detail } = this.state
        if (!detail?.id) return
        this.setState({ syncing: true })
        syncVibeAdminDatabaseReadme({ id: detail.id })
            .then(res => {
                message.success('数据库字典已同步')
                this.setState({ detail: res })
                this.loadList()
            })
            .catch(() => {})
            .finally(() => this.setState({ syncing: false }))
    }

    syncAllDatabaseReadme = () => {
        Modal.confirm({
            title: '确认批量同步数据字典？',
            content: '将从各应用 GitLab 项目根目录读取 DATA_DICTIONARY.md 并写入应用表，单个应用失败不会影响其他应用。',
            okText: '同步',
            onOk: () => {
                this.setState({ batchSyncing: true })
                return syncAllVibeAdminDatabaseReadme({})
                    .then(res => {
                        const total = res?.total || 0
                        const success = res?.success || 0
                        const failed = res?.failed || 0
                        if (failed > 0) {
                            message.warning(`批量同步完成：成功 ${success} 个，失败 ${failed} 个，共 ${total} 个`)
                        } else {
                            message.success(`批量同步完成：成功 ${success} 个，共 ${total} 个`)
                        }
                        this.loadList()
                    })
                    .catch(() => {})
                    .finally(() => this.setState({ batchSyncing: false }))
            },
        })
    }

    openEditDictionary = () => {
        const { detail } = this.state
        if (!detail?.id) return
        this.setState({
            editDictionaryVisible: true,
            editDictionaryContent: detail.databaseReadmeMd || '',
        })
    }

    saveDatabaseReadme = () => {
        const { detail, editDictionaryContent } = this.state
        if (!detail?.id) return
        this.setState({ editDictionarySaving: true })
        updateVibeAdminDatabaseReadme({
            id: detail.id,
            databaseReadmeMd: editDictionaryContent,
        }).then(res => {
            message.success('数据库字典已保存')
            this.setState({
                detail: res,
                editDictionaryVisible: false,
            })
            this.loadList()
        }).catch(() => {})
            .finally(() => this.setState({ editDictionarySaving: false }))
    }

    openDataDrawer = (record) => {
        this.setState({
            dataVisible: true,
            dataProject: record,
            tableKeyword: '',
            tableLoading: false,
            tableList: [],
            selectedTableName: '',
            dataKeyword: '',
            dataFilterColumn: undefined,
            dataFilterOperator: 'contains',
            dataFilterValue: '',
            tableDataLoading: false,
            tableColumns: [],
            tableRows: [],
            tableLastDataTime: null,
            tableDataPagination: { current: 1, pageSize: 30, total: 0 },
        }, () => this.loadProjectTables())
    }

    loadProjectTables = (keyword = this.state.tableKeyword) => {
        const { dataProject } = this.state
        if (!dataProject?.id) return Promise.resolve()
        this.setState({ tableLoading: true, tableKeyword: keyword })
        return getVibeAdminProjectTables({ projectId: dataProject.id, keyword })
            .then(res => {
                const tables = res?.tables || []
                const selectedExists = tables.some(item => item.tableName === this.state.selectedTableName)
                this.setState({ tableList: tables })
                if (tables.length && !selectedExists) {
                    this.selectTable(tables[0].tableName)
                } else if (!tables.length) {
                    this.setState({
                        selectedTableName: '',
                        dataKeyword: '',
                        dataFilterColumn: undefined,
                        dataFilterOperator: 'contains',
                        dataFilterValue: '',
                        tableColumns: [],
                        tableRows: [],
                        tableLastDataTime: null,
                        tableDataPagination: { current: 1, pageSize: 30, total: 0 },
                    })
                }
            })
            .catch(() => {})
            .finally(() => this.setState({ tableLoading: false }))
    }

    selectTable = (tableName) => {
        if (!tableName) return
        this.setState({
            selectedTableName: tableName,
            dataKeyword: '',
            dataFilterColumn: undefined,
            dataFilterOperator: 'contains',
            dataFilterValue: '',
            tableRows: [],
            tableColumns: [],
            tableLastDataTime: null,
            tableDataPagination: { ...this.state.tableDataPagination, current: 1 },
        }, () => this.loadTableData(1, this.state.tableDataPagination.pageSize, ''))
    }

    loadTableData = (
        pageNum = this.state.tableDataPagination.current,
        pageSize = this.state.tableDataPagination.pageSize,
        keyword = this.state.dataKeyword,
        filterColumn = this.state.dataFilterColumn,
        filterOperator = this.state.dataFilterOperator,
        filterValue = this.state.dataFilterValue,
    ) => {
        const { dataProject, selectedTableName } = this.state
        if (!dataProject?.id || !selectedTableName) return Promise.resolve()
        this.setState({
            tableDataLoading: true,
            dataKeyword: keyword,
            dataFilterColumn: filterColumn,
            dataFilterOperator: filterOperator,
            dataFilterValue: filterValue,
        })
        return getVibeAdminProjectTableData({
            projectId: dataProject.id,
            tableName: selectedTableName,
            keyword,
            filterColumn,
            filterOperator,
            filterValue,
            pageNum,
            pageSize,
        }).then(res => {
            this.setState({
                tableColumns: res?.columns || [],
                tableRows: (res?.rows || []).map((item, index) => ({ ...item, __rowKey: `${pageNum}-${index}` })),
                tableLastDataTime: res?.lastDataTime || null,
                tableDataPagination: {
                    current: res?.pageNum || pageNum,
                    pageSize: res?.pageSize || pageSize,
                    total: res?.total || 0,
                },
            })
        }).catch(() => {})
            .finally(() => this.setState({ tableDataLoading: false }))
    }

    renderStatus = (status) => {
        const meta = STATUS_MAP[status] || { text: status || '-', color: 'default' }
        return <Tag color={meta.color}>{meta.text}</Tag>
    }

    formatCount = value => value === null || value === undefined
        ? '-'
        : String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    formatDictionaryError = error => {
        if (!error) return ''
        return String(error).includes('404 Not Found') ? '字典文件未提交' : error
    }

    getUserValue = item => item.userId || item.USER_ID || item.user_id || item.id || item.value

    getUserLabel = item => {
        const name = item.userNick || item.USER_NICK || item.user_nick || item.nick || item.label || ''
        const account = item.userName || item.USER_NAME || item.user_name || item.name || item.email || this.getUserValue(item)
        return name && account && name !== account ? `${name}（${account}）` : (name || account || '-')
    }

    getDepartmentRowSpan = index => {
        const { dataSource } = this.state
        const department = dataSource[index]?.dingdingDeptNames || '未设置部门'
        if (index > 0 && (dataSource[index - 1]?.dingdingDeptNames || '未设置部门') === department) return 0
        let rowSpan = 1
        while (index + rowSpan < dataSource.length
            && (dataSource[index + rowSpan]?.dingdingDeptNames || '未设置部门') === department) {
            rowSpan += 1
        }
        return rowSpan
    }

    renderColumns = () => [
        {
            title: '应用',
            key: 'project',
            width: 260,
            render: (_, record) => (
                <div>
                    <Space size={6} style={{ marginBottom: 6, flexWrap: 'wrap' }}>
                        <Text strong>{record.projectName || '-'}</Text>
                        <Text code style={{ fontSize: 12 }}>{record.projectSlug || '-'}</Text>
                    </Space>
                    <div><Text type="secondary">{record.description || '暂无描述'}</Text></div>
                </div>
            ),
        },
        {
            title: '所属用户',
            key: 'owner',
            width: 180,
            render: (_, record) => (
                <div>
                    <div>{record.ownerUserNick || record.ownerUserName || '-'}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>{record.ownerUserName || record.ownerUserId || '-'}</Text>
                </div>
            ),
        },
        {
            title: '钉钉部门',
            dataIndex: 'dingdingDeptNames',
            width: 190,
            render: (value, _, index) => ({
                children: <Text>{value || '未设置部门'}</Text>,
                props: { rowSpan: this.getDepartmentRowSpan(index) },
            }),
        },
        {
            title: '状态',
            dataIndex: 'status',
            width: 100,
            render: this.renderStatus,
        },
        {
            title: '数据库',
            key: 'database',
            width: 220,
            render: (_, record) => (
                <div>
                    <Text code>{record.mysqlDatabaseName || '-'}</Text>
                    {record.mysqlConnectionName ? (
                        <div style={{ marginTop: 4 }}><Text type="secondary">{record.mysqlConnectionName}</Text></div>
                    ) : null}
                    <div style={{ marginTop: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>{record.mysqlHost || '-'}:{record.mysqlPort || '-'}</Text>
                    </div>
                    <div style={{ marginTop: 4 }}>{record.mysqlDatabaseStatus ? <Tag>{record.mysqlDatabaseStatus}</Tag> : null}</div>
                </div>
            ),
        },
        {
            title: '表数量',
            dataIndex: 'databaseTableCount',
            width: 100,
            render: (value, record) => record.databaseStatsError
                ? <Text type="danger">获取失败</Text>
                : this.formatCount(value),
        },
        {
            title: '数据量（估算）',
            dataIndex: 'databaseRowCount',
            width: 130,
            render: (value, record) => record.databaseStatsError
                ? <Text type="danger">获取失败</Text>
                : value === null || value === undefined ? '-' : `约 ${this.formatCount(value)}`,
        },
        {
            title: '部署',
            key: 'deploy',
            width: 240,
            render: (_, record) => (
                <div>
                    <div>{record.deployHostName || '-'}</div>
                    <Paragraph style={{ marginBottom: 0 }} ellipsis={{ rows: 1 }} copyable={record.publicUrl ? { text: record.publicUrl } : false}>
                        <Text type="secondary">{record.publicUrl || '-'}</Text>
                    </Paragraph>
                </div>
            ),
        },
        {
            title: '字典同步',
            key: 'dictionary',
            width: 230,
            render: (_, record) => {
                const contentLength = Number(record.databaseReadmeLength) || 0
                return (
                    <div>
                        <Space size={6}>
                            <Tag color={contentLength > 0 ? 'success' : 'error'}>
                                {contentLength > 0 ? '已有内容' : '暂无内容'}
                            </Tag>
                            {contentLength > 0 ? <Text type="secondary" style={{ fontSize: 12 }}>{contentLength} 字符</Text> : null}
                        </Space>
                        <div style={{ marginTop: 4 }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                数据更新：{record.databaseReadmeSyncedAt || '-'}
                            </Text>
                        </div>
                        {contentLength <= 0 && record.databaseReadmeError ? (
                            <Paragraph type="danger" style={{ fontSize: 12, marginBottom: 0 }} ellipsis={{ rows: 2 }}>
                                {this.formatDictionaryError(record.databaseReadmeError)}
                            </Paragraph>
                        ) : null}
                    </div>
                )
            },
        },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: 170,
            render: (_, record) => (
                <Space size={8} wrap>
                    <Button size="small" type="primary" ghost onClick={() => this.openDetail(record)}>详情</Button>
                    <Button size="small" icon={<DatabaseOutlined />} onClick={() => this.openDataDrawer(record)}>数据</Button>
                </Space>
            ),
        },
    ]

    renderDetailDrawer = () => {
        const { detailVisible, detailLoading, detail, health, healthLoading, syncing } = this.state
        return (
            <Drawer
                title={detail ? `应用详情：${detail.projectName || detail.projectSlug}` : '应用详情'}
                visible={detailVisible}
                width={900}
                onClose={() => this.setState({ detailVisible: false })}
                destroyOnClose
            >
                <Space style={{ marginBottom: 16 }} wrap>
                    <Button icon={<ReloadOutlined />} loading={healthLoading} onClick={this.checkHealth}>检查运行状态</Button>
                    <Button type="primary" ghost icon={<FileTextOutlined />} loading={syncing} onClick={this.syncDatabaseReadme}>
                        同步数据字典
                    </Button>
                </Space>
                <Spin spinning={detailLoading}>
                {detail ? (
                    <Tabs defaultActiveKey="info">
                        <TabPane tab={<span><CloudServerOutlined />应用信息</span>} key="info">
                            <Descriptions bordered column={2} size="small">
                                <Descriptions.Item label="应用名称">{detail.projectName || '-'}</Descriptions.Item>
                                <Descriptions.Item label="状态">{this.renderStatus(detail.status)}</Descriptions.Item>
                                <Descriptions.Item label="所属用户">{detail.ownerUserNick || detail.ownerUserName || '-'}</Descriptions.Item>
                                <Descriptions.Item label="GitLab 项目">
                                    {detail.gitlabWebUrl ? <a href={detail.gitlabWebUrl} target="_blank" rel="noreferrer">{detail.gitlabProjectPath || detail.gitlabWebUrl}</a> : '-'}
                                </Descriptions.Item>
                                <Descriptions.Item label="公开地址" span={2}>
                                    <Paragraph copyable={detail.publicUrl ? { text: detail.publicUrl } : false} style={{ marginBottom: 0 }}>
                                        {detail.publicUrl || '-'}
                                    </Paragraph>
                                </Descriptions.Item>
                                <Descriptions.Item label="部署服务器">{detail.deployHostName || '-'}</Descriptions.Item>
                                <Descriptions.Item label="部署端口">{detail.deployPort || '-'}</Descriptions.Item>
                                <Descriptions.Item label="部署目录" span={2}>{detail.deployPath || '-'}</Descriptions.Item>
                                <Descriptions.Item label="健康检查">{detail.healthPath || '-'}</Descriptions.Item>
                                <Descriptions.Item label="最近接入">{detail.lastProvisionedAt || '-'}</Descriptions.Item>
                            </Descriptions>
                            {health ? (
                                <div style={{ marginTop: 16, padding: 12, border: '1px solid #edf0f5', background: '#fafafa' }}>
                                    <Space style={{ marginBottom: 8 }}>
                                        <Text strong>运行状态</Text>
                                        <Tag color={health.healthy ? 'success' : 'error'}>{health.healthy ? '健康' : '异常'}</Tag>
                                        {health.statusCode ? <Tag>{health.statusCode}</Tag> : null}
                                    </Space>
                                    <Paragraph copyable={health.healthUrl ? { text: health.healthUrl } : false}>{health.healthUrl || health.message || '-'}</Paragraph>
                                    {health.body ? <pre style={{ whiteSpace: 'pre-wrap', marginBottom: 0 }}>{health.body}</pre> : null}
                                </div>
                            ) : null}
                        </TabPane>
                        <TabPane tab={<span><DatabaseOutlined />数据库字典</span>} key="dictionary">
                            <Space style={{ marginBottom: 12 }} wrap>
                                <Button type="primary" ghost icon={<FileTextOutlined />} onClick={this.openEditDictionary}>
                                    编辑字典
                                </Button>
                            </Space>
                            <Descriptions bordered column={2} size="small" style={{ marginBottom: 12 }}>
                                <Descriptions.Item label="数据库">{detail.mysqlDatabaseName || '-'}</Descriptions.Item>
                                <Descriptions.Item label="数据库连接">{detail.mysqlConnectionName || '默认连接'}</Descriptions.Item>
                                <Descriptions.Item label="Host/Port">{detail.mysqlHost || '-'}:{detail.mysqlPort || '-'}</Descriptions.Item>
                                <Descriptions.Item label="JDBC URL" span={2}>
                                    <Paragraph copyable={detail.mysqlJdbcUrl ? { text: detail.mysqlJdbcUrl } : false} style={{ marginBottom: 0 }}>
                                        {detail.mysqlJdbcUrl || '-'}
                                    </Paragraph>
                                </Descriptions.Item>
                                <Descriptions.Item label="同步时间">{detail.databaseReadmeSyncedAt || '-'}</Descriptions.Item>
                                <Descriptions.Item label="同步错误" span={2}>
                                    {detail.databaseReadmeMd ? '-' : (this.formatDictionaryError(detail.databaseReadmeError) || '-')}
                                </Descriptions.Item>
                            </Descriptions>
                            <pre style={{ minHeight: 260, whiteSpace: 'pre-wrap', background: '#0f172a', color: '#e5e7eb', padding: 16, overflow: 'auto' }}>
                                {detail.databaseReadmeMd || '暂无 DATA_DICTIONARY.md 内容'}
                            </pre>
                        </TabPane>
                        <TabPane tab="日志" key="logs">
                            <Table
                                size="small"
                                rowKey="id"
                                dataSource={detail.provisionLogs || []}
                                pagination={false}
                                columns={[
                                    { title: '时间', dataIndex: 'createTime', width: 170 },
                                    { title: '步骤', dataIndex: 'stepName', width: 160 },
                                    { title: '状态', dataIndex: 'stepStatus', width: 100, render: v => <Tag>{v || '-'}</Tag> },
                                    { title: '消息', dataIndex: 'message' },
                                ]}
                            />
                        </TabPane>
                    </Tabs>
                ) : null}
                </Spin>
                {this.renderDictionaryModal()}
            </Drawer>
        )
    }

    renderDataDrawer = () => {
        const {
            dataVisible,
            dataProject,
            tableKeyword,
            tableLoading,
            tableList,
            selectedTableName,
            dataKeyword,
            dataFilterColumn,
            dataFilterOperator,
            dataFilterValue,
            tableDataLoading,
            tableColumns,
            tableRows,
            tableLastDataTime,
            tableDataPagination,
        } = this.state
        const visibleTableColumns = tableColumns.filter(column => String(column.columnName).toLowerCase() !== 'id')
        const dataColumns = [
            {
                title: '序号',
                key: '__index',
                width: 70,
                fixed: 'left',
                render: (value, record, index) => ((tableDataPagination.current || 1) - 1) * (tableDataPagination.pageSize || 30) + index + 1,
            },
            ...visibleTableColumns.map(column => ({
                title: (
                    <div>
                        <div>{column.columnName}</div>
                        {column.columnComment ? <Text type="secondary" style={{ fontSize: 12 }}>{column.columnComment}</Text> : null}
                    </div>
                ),
                dataIndex: column.columnName,
                key: column.columnName,
                width: 160,
                ellipsis: true,
                render: value => value === null || value === undefined ? <Text type="secondary">NULL</Text> : String(value),
            })),
        ]
        return (
            <Drawer
                title={dataProject ? `项目数据：${dataProject.projectName || dataProject.projectSlug}` : '项目数据'}
                visible={dataVisible}
                width="92%"
                onClose={() => this.setState({ dataVisible: false })}
                destroyOnClose
                bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'hidden' }}
            >
                <div style={{ display: 'flex', gap: 16, height: '100%', minHeight: 0 }}>
                    <div style={{ width: 300, borderRight: '1px solid #edf0f5', paddingRight: 12, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <Input.Search
                            allowClear
                            placeholder="筛选表"
                            value={tableKeyword}
                            onChange={e => this.setState({ tableKeyword: e.target.value })}
                            onSearch={value => this.loadProjectTables(value)}
                            style={{ marginBottom: 12 }}
                        />
                        <Table
                            rowKey="tableName"
                            size="small"
                            loading={tableLoading}
                            dataSource={tableList}
                            pagination={false}
                            scroll={{ y: 'calc(100vh - 195px)' }}
                            rowClassName={record => record.tableName === selectedTableName ? 'ant-table-row-selected' : ''}
                            onRow={record => ({ onClick: () => this.selectTable(record.tableName) })}
                            columns={[
                                {
                                    title: '表',
                                    dataIndex: 'tableName',
                                    render: (value, record) => (
                                        <div>
                                            <Text strong={value === selectedTableName}>{value}</Text>
                                            {record.tableComment ? <div><Text type="secondary" style={{ fontSize: 12 }}>{record.tableComment}</Text></div> : null}
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </div>
                    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                            <Space>
                                <Text strong>{selectedTableName || '请选择表'}</Text>
                                {dataProject?.mysqlDatabaseName ? <Text code>{dataProject.mysqlDatabaseName}</Text> : null}
                                {selectedTableName ? (
                                    <Text type="secondary">最后数据上传时间：{tableLastDataTime || '暂无时间字段'}</Text>
                                ) : null}
                            </Space>
                            <Space wrap style={{ justifyContent: 'flex-end' }}>
                                <Input.Search
                                    allowClear
                                    placeholder="全表关键字"
                                    value={dataKeyword}
                                    onChange={e => this.setState({ dataKeyword: e.target.value })}
                                    onSearch={value => this.loadTableData(1, tableDataPagination.pageSize, value)}
                                    style={{ width: 210 }}
                                    disabled={!selectedTableName}
                                />
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="选择字段"
                                    value={dataFilterColumn}
                                    optionFilterProp="children"
                                    style={{ width: 190 }}
                                    disabled={!selectedTableName}
                                    onChange={value => this.setState({ dataFilterColumn: value })}
                                >
                                    {visibleTableColumns.map(column => (
                                        <Option key={column.columnName} value={column.columnName}>
                                            {column.columnComment ? `${column.columnName} / ${column.columnComment}` : column.columnName}
                                        </Option>
                                    ))}
                                </Select>
                                <Select
                                    value={dataFilterOperator}
                                    style={{ width: 100 }}
                                    disabled={!selectedTableName || !dataFilterColumn}
                                    onChange={value => this.setState({ dataFilterOperator: value })}
                                >
                                    <Option value="contains">包含</Option>
                                    <Option value="eq">等于</Option>
                                    <Option value="startsWith">开头是</Option>
                                    <Option value="endsWith">结尾是</Option>
                                    <Option value="gt">大于</Option>
                                    <Option value="gte">大于等于</Option>
                                    <Option value="lt">小于</Option>
                                    <Option value="lte">小于等于</Option>
                                </Select>
                                <Input.Search
                                    allowClear
                                    placeholder="字段值"
                                    value={dataFilterValue}
                                    onChange={e => this.setState({ dataFilterValue: e.target.value })}
                                    onSearch={value => this.loadTableData(1, tableDataPagination.pageSize, dataKeyword, dataFilterColumn, dataFilterOperator, value)}
                                    style={{ width: 190 }}
                                    disabled={!selectedTableName || !dataFilterColumn}
                                />
                            </Space>
                        </div>
                        <Table
                            rowKey="__rowKey"
                            size="small"
                            loading={tableDataLoading}
                            dataSource={tableRows}
                            columns={dataColumns}
                            scroll={{ x: Math.max(70 + visibleTableColumns.length * 160, 900), y: 'calc(100vh - 250px)' }}
                            pagination={{
                                ...tableDataPagination,
                                pageSize: 30,
                                showSizeChanger: false,
                                showTotal: (total, range) => `${range[0]}-${range[1]} / 共 ${total} 行，每页 30 条`,
                            }}
                            onChange={page => this.loadTableData(page.current, 30)}
                        />
                    </div>
                </div>
            </Drawer>
        )
    }

    renderDictionaryModal = () => {
        const { editDictionaryVisible, editDictionaryContent, editDictionarySaving, detail } = this.state
        return (
            <Modal
                title={`编辑数据库字典：${detail?.projectName || detail?.projectSlug || ''}`}
                visible={editDictionaryVisible}
                width={900}
                okText="保存"
                confirmLoading={editDictionarySaving}
                onOk={this.saveDatabaseReadme}
                onCancel={() => this.setState({ editDictionaryVisible: false })}
                destroyOnClose
            >
                <Input.TextArea
                    value={editDictionaryContent}
                    rows={20}
                    placeholder="可粘贴或维护 DATA_DICTIONARY.md 内容"
                    onChange={e => this.setState({ editDictionaryContent: e.target.value })}
                />
            </Modal>
        )
    }

    renderAdminModals = () => {
        const {
            users,
            mysqlConnections,
            appCreateVisible,
            appCreating,
            connectionManageVisible,
            connectionEditVisible,
            connectionSaving,
            editingConnection,
        } = this.state
        const enabledConnections = mysqlConnections.filter(item => item.status === 'enabled')
        return (
            <>
                <Modal
                    title="新建 Vibe 应用"
                    visible={appCreateVisible}
                    okText="创建"
                    confirmLoading={appCreating}
                    onOk={this.submitCreateApp}
                    onCancel={() => this.setState({ appCreateVisible: false })}
                    destroyOnClose
                >
                    <Form ref={this.appFormRef} layout="vertical">
                        <Form.Item label="所属用户" name="ownerUserId" rules={[{ required: true, message: '请选择所属用户' }]}>
                            <Select showSearch optionFilterProp="children" placeholder="选择用户">
                                {users.map(item => (
                                    <Option key={this.getUserValue(item)} value={this.getUserValue(item)}>
                                        {this.getUserLabel(item)}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="项目名称"
                            name="projectName"
                            rules={[
                                { required: true, message: '请输入项目名称' },
                                { pattern: /^[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?$/, message: '只能使用小写字母、数字和短横线，最长64位' },
                            ]}
                        >
                            <Input placeholder="例如 sales-report" maxLength={64} />
                        </Form.Item>
                        <Form.Item label="项目简介" name="description">
                            <Input.TextArea rows={3} maxLength={500} placeholder="填写应用用途和业务范围" />
                        </Form.Item>
                        <Form.Item label="数据库连接" name="mysqlConnectionId" rules={[{ required: true, message: '请选择数据库连接' }]}>
                            <Select placeholder="选择数据库连接">
                                {enabledConnections.map(item => (
                                    <Option key={item.id} value={item.id}>
                                        {item.connectionName}（{item.mysqlHost}:{item.mysqlPort}）
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="数据库名"
                            name="mysqlDatabaseName"
                            rules={[
                                { required: true, message: '请输入数据库名' },
                                { pattern: /^[a-z0-9_-]{1,64}$/, message: '只能使用小写字母、数字、下划线和中划线，最长64位' },
                            ]}
                        >
                            <Input placeholder="例如 vibe_sales_report" maxLength={64} />
                        </Form.Item>
                        <Form.Item name="skipDatabaseCreation" valuePropName="checked">
                            <Checkbox>跳过创建数据库（默认数据库已存在）</Checkbox>
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title="数据库连接"
                    visible={connectionManageVisible}
                    width={1000}
                    footer={<Button onClick={() => this.setState({ connectionManageVisible: false })}>关闭</Button>}
                    onCancel={() => this.setState({ connectionManageVisible: false })}
                >
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                        <Button type="primary" icon={<PlusOutlined />} onClick={this.openCreateConnection}>新增连接</Button>
                    </div>
                    <Table
                        rowKey="id"
                        size="small"
                        dataSource={mysqlConnections}
                        pagination={false}
                        columns={[
                            { title: '名称', dataIndex: 'connectionName', width: 150 },
                            { title: '连接地址', key: 'address', render: (_, item) => `${item.mysqlHost}:${item.mysqlPort}` },
                            { title: '数据库', dataIndex: 'connectionDatabase', width: 140 },
                            { title: '状态', dataIndex: 'status', width: 90, render: value => <Tag color={value === 'enabled' ? 'success' : 'default'}>{value === 'enabled' ? '启用' : '禁用'}</Tag> },
                            { title: '备注', dataIndex: 'remark', render: value => value || '-' },
                            { title: '操作', width: 90, render: (_, item) => <Button size="small" onClick={() => this.openEditConnection(item)}>编辑</Button> },
                        ]}
                    />
                </Modal>

                <Modal
                    title={editingConnection ? '编辑数据库连接' : '新增数据库连接'}
                    visible={connectionEditVisible}
                    okText="保存"
                    width={620}
                    confirmLoading={connectionSaving}
                    onOk={this.saveConnection}
                    onCancel={() => this.setState({ connectionEditVisible: false })}
                    footer={[
                        <Button key="cancel" onClick={() => this.setState({ connectionEditVisible: false })}>取消</Button>,
                        <Button key="save" type="primary" loading={connectionSaving} onClick={this.saveConnection}>保存</Button>,
                    ]}
                    destroyOnClose
                >
                    <Form ref={this.connectionFormRef} layout="vertical">
                        <Form.Item label="连接名称" name="connectionName" rules={[{ required: true, message: '请输入连接名称' }]}>
                            <Input maxLength={128} placeholder="例如 生产 Vibe MySQL" />
                        </Form.Item>
                        <Space size={12} style={{ display: 'flex' }} align="start">
                            <Form.Item label="数据库连接" name="mysqlHost" rules={[{ required: true, message: '请输入数据库连接' }]} style={{ flex: 1 }}>
                                <Input placeholder="mysql.example.com" />
                            </Form.Item>
                            <Form.Item label="端口" name="mysqlPort" rules={[{ required: true, message: '请输入端口' }]}>
                                <InputNumber min={1} max={65535} style={{ width: 130 }} />
                            </Form.Item>
                        </Space>
                        <Space size={12} style={{ display: 'flex' }} align="start">
                            <Form.Item
                                label="数据库"
                                name="connectionDatabase"
                                rules={[
                                    { pattern: /^[a-z0-9_-]{1,64}$/, message: '只能使用小写字母、数字、下划线和中划线，最长64位' },
                                ]}
                                style={{ flex: 1 }}
                            >
                                <Input placeholder="选填，例如 vibe-ops" />
                            </Form.Item>
                            <Form.Item label="状态" name="status" rules={[{ required: true }]} style={{ width: 130 }}>
                                <Select><Option value="enabled">启用</Option><Option value="disabled">禁用</Option></Select>
                            </Form.Item>
                        </Space>
                        <Form.Item label="备注" name="remark">
                            <Input.TextArea rows={2} maxLength={500} />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        )
    }

    render() {
        const {
            dataSource, pagination, loading, keyword, batchSyncing, dingdingDeptId, dingdingDepartments,
        } = this.state
        return (
            <div style={{ padding: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                    <Space wrap>
                        <Input
                            allowClear
                            prefix={<SearchOutlined />}
                            placeholder="搜索应用、用户、数据库"
                            value={keyword}
                            onChange={e => this.setState({ keyword: e.target.value })}
                            onPressEnter={() => this.loadList(1)}
                            style={{ width: 260 }}
                        />
                        <Select
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            placeholder="按钉钉部门分类"
                            value={dingdingDeptId}
                            onChange={value => this.setState({ dingdingDeptId: value }, () => this.loadList(1))}
                            style={{ width: 240 }}
                        >
                            {dingdingDepartments.map(item => (
                                <Option key={item.dingdingDeptId} value={item.dingdingDeptId}>
                                    {item.dingdingDeptName}
                                </Option>
                            ))}
                        </Select>
                        <Button type="primary" icon={<SearchOutlined />} onClick={() => this.loadList(1)}>查询</Button>
                        <Button icon={<FileTextOutlined />} loading={batchSyncing} onClick={this.syncAllDatabaseReadme}>
                            批量同步数据字典
                        </Button>
                        <Button type="primary" icon={<PlusOutlined />} onClick={this.openCreateApp}>新建应用</Button>
                        <Button icon={<SettingOutlined />} onClick={() => this.setState({ connectionManageVisible: true })}>
                            数据库连接
                        </Button>
                    </Space>
                </div>
                <Table
                    rowKey="id"
                    size="middle"
                    loading={loading}
                    dataSource={dataSource}
                    columns={this.renderColumns()}
                    scroll={{ x: 1720 }}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: total => `共 ${total} 个应用`,
                    }}
                    onChange={page => this.loadList(page.current, page.pageSize)}
                />
                {this.renderDetailDrawer()}
                {this.renderDataDrawer()}
                {this.renderAdminModals()}
            </div>
        )
    }
}
